module.exports = __webpack_public_path__ + "img/PicsSamsung.1796e78e.png";